import { render, staticRenderFns } from "./insurance1.vue?vue&type=template&id=2953da1c&scoped=true"
import script from "./insurance1.vue?vue&type=script&lang=js"
export * from "./insurance1.vue?vue&type=script&lang=js"
import style0 from "./insurance1.vue?vue&type=style&index=0&id=2953da1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953da1c",
  null
  
)

export default component.exports